export const STAGING_HOSTNAME = "dev.das-ist-thueringen.neueseite.eu"